"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreSubCollection = exports.FirestoreCollection = void 0;
var FirestoreCollection;
(function (FirestoreCollection) {
    FirestoreCollection["Cities"] = "cities";
    FirestoreCollection["CustomerSupport"] = "customer-support";
    FirestoreCollection["DataDelete"] = "data-delete";
    FirestoreCollection["Payout"] = "payouts";
    FirestoreCollection["Planner"] = "planners";
    FirestoreCollection["Registration"] = "registrations";
    FirestoreCollection["User"] = "users";
    FirestoreCollection["Admin"] = "admins";
})(FirestoreCollection = exports.FirestoreCollection || (exports.FirestoreCollection = {}));
var FirestoreSubCollection;
(function (FirestoreSubCollection) {
    FirestoreSubCollection["Referral"] = "referrals";
})(FirestoreSubCollection = exports.FirestoreSubCollection || (exports.FirestoreSubCollection = {}));
